<template>
  <DocsLayout
    heading="Returns"
    :content="content"
    :navigation="navigation"
    :selected-nav="selectedCategory"
    @sideBarLinkClicked="handleSectionClick"
  />
</template>

<script>
import ReturnsContent from "@/content/Returns.json";
import DocsLayout from "@/layouts/DocsLayout.vue";

export default {
  name: "Returns",
  components: {
    DocsLayout,
  },
  data() {
    return {
      returnsJson: ReturnsContent,
      navigation: ReturnsContent,
      content: null,
      selectedCategory: null,
      selectedCategoryIndex: 0,
    };
  },
  mounted() {
    const url = new URL(window.location);
    const categorySlug = url.searchParams.get("category");

    const matchedCategory = this.navigation.find(
      (category) => category.slug === categorySlug
    );

    // Set the selected category as the first category by default
    if (matchedCategory) {
      this.selectedCategoryIndex = this.navigation.indexOf(matchedCategory);
      this.selectedCategory = matchedCategory;
    }

    this.content = [
      {
        ...ReturnsContent[this.selectedCategoryIndex],
        index: this.selectedCategoryIndex,
      },
    ];
  },
  methods: {
    handleSectionClick(clickedSection) {
      this.selectedCategory = clickedSection;
      this.setUrl(clickedSection);

      if (clickedSection) {
        const sections = this.returnsJson;
        const selectedContent = sections.find(
          (section) => section.name === clickedSection.name
        );

        const index = sections.indexOf(selectedContent);

        this.content = [{ ...selectedContent, index }];
      }
    },
    setUrl(section) {
      const url = new URL(window.location);

      if (section) {
        url.searchParams.set("category", section.slug);
      } else {
        url.searchParams.delete("category");
      }

      window.history.pushState(null, "", url.toString());
    },
  },
};
</script>
